import GetIcon from "@/components/font-awesome-icon";
import UIToggleButton from "@/components/ui-controls/toggle-buttons";
import {
  getTasksViewType,
  setTasksViewTypeToState,
} from "@/store/slices/tasks/tasksSlice";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { faList, faTableColumns } from "@fortawesome/free-solid-svg-icons";
import { Box, Typography } from "@mui/material";
import { useSelector , useDispatch } from "react-redux";


export const viewTypeEnum = {
  view_1: "view_1",
  view_2: "view_2",
  view_3: "view_3",
};

export const ToggleTasksView = () => {
  const dispatch = useDispatch();
  const viewType = useSelector(getTasksViewType);

  const handleViewChange = (value) => {
    dispatch(setTasksViewTypeToState(value));
  };

  return (
    <UIToggleButton
      selected={viewType}
      options={[
        {
          label: <GetIcon icon={faList} iconStyles={{ fontSize: "20px" }} />,
          value: viewTypeEnum.view_1,
        },
        {
          label: (
            <GetIcon icon={faTableColumns} iconStyles={{ fontSize: "20px" }} />
          ),
          value: viewTypeEnum.view_2,
        },
        {
          label: (
            <GetIcon icon={faCalendar} iconStyles={{ fontSize: "20px" }} />
          ),
          value: viewTypeEnum.view_3,
        },
      ]}
      handleChange={(e, value) => handleViewChange(value)}
      name={"viewOptions"}
      sx={{
        ml: 3,
        "& .MuiButtonBase-root": {
          minWidth: "60px",
          height: "38px",
          fontWeight: "normal !important",
        },
      }}
    />
  );
};

export const RenerIcon = ({
  label,
  icon,
  style = {},
  labelPlacement,
  iconSx = {},
}) => {
  return (
    <GetIcon
      title={label}
      labelPlacement={labelPlacement}
      icon={icon}
      iconStyles={{
        fontSize: "0.85rem",
        color: "var(--palette-secondary_button_text)",
        padding: "6px",
        background: "var(--palette-stroke)",
        borderRadius: "50%",
        ...style,
      }}
      sx={{ fontSize: "0.8rem !important", ...iconSx }}
    />
  );
};

export const BottomListItem = ({
  label = "",
  icon,
  children,
  sx = {},
  iconSx = {},
}) => {
  return (
    <Box
      className="d-flex justify-content-space-between align-items-center"
      sx={{ my: 1, ...sx }}
    >
      <RenerIcon
        label={
          <Typography variant="body2" sx={{}}>
            {label}
          </Typography>
        }
        icon={icon}
        iconSx={iconSx}
      />
      {children}
    </Box>
  );
};
